// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2Wxlz","description":"PatientConsentPreview_description__1eMrG"};